import { render, staticRenderFns } from "./StockManagement.vue?vue&type=template&id=56ec609f&scoped=true"
import script from "./StockManagement.vue?vue&type=script&lang=js"
export * from "./StockManagement.vue?vue&type=script&lang=js"
import style0 from "./StockManagement.vue?vue&type=style&index=0&id=56ec609f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ec609f",
  null
  
)

export default component.exports